import { render, staticRenderFns } from "./PodcastEpisodes.vue?vue&type=template&id=1b418660&scoped=true&"
import script from "./PodcastEpisodes.vue?vue&type=script&lang=js&"
export * from "./PodcastEpisodes.vue?vue&type=script&lang=js&"
import style0 from "./PodcastEpisodes.vue?vue&type=style&index=0&id=1b418660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b418660",
  null
  
)

export default component.exports